import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

export default function Progress(props) {
  return (
    <Backdrop
      data-testid="progessId"
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <CircularProgress
        variant="determinate"
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={60}
        thickness={4}
        value={100}
      />
      <CircularProgress disableShrink
        size={60}
        thickness={4}
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%'
        }}
      />
    </Backdrop>
  )
}